import React, { createContext, useContext, useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { useNavigate, useLocation } from 'react-router-dom';

const CookieContext = createContext(null);

const isTrueValue = (value) => value === true || String(value).toLowerCase() === "true";

export const useCookies = () => {
    return useContext(CookieContext);
};

const CookieChecker = ({ children }) => {
  const [user, setUser] = useState(null);
  const [type, setType] = useState(null);
  const [token, setToken] = useState(null);
  const [name, setName] = useState(null);
  const [id, setId] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [superRole, setSuperRole] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const cookies = new Cookies();
    const userCookie = cookies.get("user");
    const nameCookie = cookies.get("name");
    const typeCookie = cookies.get("type");
    const tokenCookie = cookies.get("token");
    const idCookie = cookies.get("id");
    const currencyCookie = cookies.get("currency");
    const superCookie = cookies.get("super");
    const isSuperAdmin = isTrueValue(superCookie) || typeCookie === "SUPERADMIN";

    const isAdminRoute = location.pathname.startsWith("/admin");

    if (!tokenCookie || !typeCookie) {
      if (isAdminRoute) navigate("/admin/login");
      else navigate("/login");
      return;
    }

    //You are a regular user and are trying to view an administrator view
    if (isAdminRoute && (typeCookie !== "ADMIN" && typeCookie !== "SUPERADMIN")) {
      navigate("/dashboard");
      return;
    }

    if (!isAdminRoute && (typeCookie === "ADMIN" || typeCookie === "SUPERADMIN")) {
      navigate("/admin/requests");
      return;
    }

    if (location.pathname === "/admin/administration" && isSuperAdmin !== true) {
      navigate("/admin/requests");
      return;
    }

    setUser(userCookie);
    setName(nameCookie);
    setType(typeCookie);
    setToken(tokenCookie);
    setId(idCookie);
    setCurrency(currencyCookie);
    setSuperRole(isSuperAdmin);
    setIsChecking(false);
  }, [navigate, location]);

  if (isChecking) {
    return (
      <>
      </>
    );
  }

  return (
      <CookieContext.Provider value={{ user, name, type, token, id, currency, superRole }}>
          {children}
      </CookieContext.Provider>
  );
};

export default CookieChecker;
